import React from "react";
import { Facebook, Instagram, Youtube, Twitter } from "lucide-react";

export const Footer = () => (
  <footer className="mt-16 bg-[#50000E] text-amber-100">
    <div className="sacred-divider" />
    <div className="max-w-7xl mx-auto px-4 py-10 grid gap-8 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3 mb-3">
          <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center ring-2 ring-[#DAA520]/60 overflow-hidden shrink-0">
            <img src="https://customer-assets-jt897jd0.emergentagent.net/job_temple-booking-hub-4/artifacts/a6054c377532a45a_images.png" alt="TTD Logo" className="w-12 h-12 object-contain" />
          </div>
          <div className="font-cinzel text-xl text-[#DAA520] font-bold">TTD Devasthanams</div>
        </div>
        <p className="text-sm text-amber-200/80 leading-relaxed">
          Tirumala Tirupati Devasthanams is an independent trust managing the Tirumala
          Sri Venkateswara Temple and allied temples in Andhra Pradesh, India.
        </p>
      </div>
      <div>
        <div className="font-semibold text-amber-50 mb-3 uppercase text-xs tracking-widest">Quick Links</div>
        <ul className="space-y-2 text-sm text-amber-200/80">
          <li>Terms and Conditions</li>
          <li>Guidelines & FAQs</li>
          <li>Feedback</li>
          <li>Call Center (24X7): 155 257</li>
        </ul>
      </div>
      <div>
        <div className="font-semibold text-amber-50 mb-3 uppercase text-xs tracking-widest">Connect</div>
        <div className="flex gap-3">
          {[Facebook, Twitter, Instagram, Youtube].map((Icon, i) => (
            <div key={i} className="w-9 h-9 rounded-full bg-[#7A0016] flex items-center justify-center hover:bg-[#DAA520] hover:text-[#50000E] transition-colors cursor-pointer">
              <Icon className="w-4 h-4" />
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-[#DAA520]/20 py-4 text-center text-xs text-amber-200/70">
      Copyright © 2026 Tirumala Tirupati Devasthanams — All rights reserved. This is a demo replica portal.
    </div>
  </footer>
);
